import { MatterViewerRole } from '@/matter/store/schemas'
import type { MatterRead, MatterReadForTable } from '@/matter/store/schemas'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'

/**
 * Returns true when the current user has a *pending* collaborator invite to this matter:
 * invited as a collaborator (invited_at set) but has not yet accepted (accepted_at null).
 *
 * Gated on the COLLABORATION feature flag so this stays inert until collaboration ships.
 * Centralizing the flag check here keeps the matters-table call sites (pill, row activation,
 * overflow-menu disabling) from each re-checking it.
 */
export function isPendingMatterInvite(matter: MatterRead | MatterReadForTable | null | undefined): boolean {
  if (!kGetFeatureFlagStatus(kFeatureFlags.COLLABORATION)) return false
  if (!matter) return false
  return matter.viewer_role === MatterViewerRole.Collaborator && matter.invited_at !== null && matter.accepted_at === null
}
